export default __webpack_public_path__ + "static/media/footer_car.96f73df7.gif";